// =============================================================================
// actions/kpiRuleActions.js
// =============================================================================
import {
	RULES_FETCH_REQUEST,
	RULES_FETCH_SUCCESS,
	RULES_FETCH_FAILURE,
	RULE_SAVE_REQUEST,
	RULE_SAVE_SUCCESS,
	RULE_SAVE_FAILURE,
	RULE_DELETE_REQUEST,
	RULE_DELETE_SUCCESS,
	RULE_DELETE_FAILURE,
	RULE_SELECT,
	RULE_FORM_RESET,
	FORMULA_VALIDATE_REQUEST,
	FORMULA_VALIDATE_SUCCESS,
	FORMULA_VALIDATE_FAILURE,
	FORMULA_VALIDATE_RESET,
	ENGINE_LOGS_FETCH_REQUEST,
	ENGINE_LOGS_FETCH_SUCCESS,
	ENGINE_LOGS_FETCH_FAILURE,
} from '../constants/kpiConstants';

import {
	apiFetchRules,
	apiCreateRule,
	apiUpdateRule,
	apiDeleteRule,
	apiValidateFormula,
	apiFetchEngineLogs,
} from '../requests/kpiRequests';

// --- Rules ---

export const fetchRules = () => async (dispatch) => {
	dispatch({ type: RULES_FETCH_REQUEST });

	try {
		const res = await apiFetchRules();

		dispatch({
			type: RULES_FETCH_SUCCESS,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: RULES_FETCH_FAILURE,
			payload: err.message,
		});
	}
};

export const saveRule = (rule) => async (dispatch) => {
	dispatch({ type: RULE_SAVE_REQUEST });

	try {
		if (rule.kpiId === 0) {
			await apiCreateRule(rule);
		} else {
			await apiUpdateRule(rule.kpiId, rule);
		}

		dispatch({ type: RULE_SAVE_SUCCESS });

		dispatch(fetchRules());
	} catch (err) {
		const msg = err.response?.data?.error || err.message;

		dispatch({
			type: RULE_SAVE_FAILURE,
			payload: msg,
		});
	}
};

export const deleteRule = (kpiId) => async (dispatch) => {
	dispatch({ type: RULE_DELETE_REQUEST });

	try {
		await apiDeleteRule(kpiId);

		dispatch({ type: RULE_DELETE_SUCCESS });

		dispatch(fetchRules());
	} catch (err) {
		dispatch({
			type: RULE_DELETE_FAILURE,
			payload: err.message,
		});
	}
};

export const selectRule = (rule) => ({
	type: RULE_SELECT,
	payload: rule,
});

export const resetRuleForm = () => ({
	type: RULE_FORM_RESET,
});

// --- Validate formula ---

export const validateFormula = (payload) => async (dispatch) => {
	dispatch({ type: FORMULA_VALIDATE_REQUEST });

	try {
		const res = await apiValidateFormula(payload);

		dispatch({
			type: FORMULA_VALIDATE_SUCCESS,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: FORMULA_VALIDATE_FAILURE,
			payload: err.message,
		});
	}
};

export const resetValidation = () => ({
	type: FORMULA_VALIDATE_RESET,
});

// --- Engine logs ---

export const fetchEngineLogs = () => async (dispatch) => {
	dispatch({ type: ENGINE_LOGS_FETCH_REQUEST });

	try {
		const res = await apiFetchEngineLogs();

		dispatch({
			type: ENGINE_LOGS_FETCH_SUCCESS,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: ENGINE_LOGS_FETCH_FAILURE,
			payload: err.message,
		});
	}
};
